import React from "react";

// project imports
import Hero from "./sections/hero/Hero";
import Navigation from "./sections/Navigation";

// MUI imports
import { Box } from "@mui/material";
import Footer from "./sections/footer/Footer";
import Contact from "./sections/contact/Contact";
import useBreakpoint from "../../hooks/useBreakpoint";
import About from "./sections/about/About";

export default function LandingPage() {
  const breakpoint = useBreakpoint();
  return (
    <div className="w-full">
      <Navigation />
      <Hero />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
